import CryptoJS from "crypto-js";
import { AES_KEY, AES_IV, TOKEN, validateEnv } from "./config";

export function generateEncryptedToken() {
  validateEnv();

  // yyyyMMddHHmmss
  const now = new Date();
  const pad = (n) => (n < 10 ? "0" + n : n);

  const datetime =
    now.getFullYear().toString() +
    pad(now.getMonth() + 1) +
    pad(now.getDate()) +
    pad(now.getHours()) +
    pad(now.getMinutes()) +
    pad(now.getSeconds());

  const tokenWithTime = `${TOKEN}$${datetime}`;

  const key = CryptoJS.enc.Utf8.parse(AES_KEY);
  const iv = CryptoJS.enc.Utf8.parse(AES_IV);

  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(tokenWithTime),
    key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  // IMPORTANT: RAW ciphertext Base64
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}
